define.alias("ember-math-helpers/helpers/imul", "calendar/helpers/imul");